import { render } from "./HomepageView.vue?vue&type=template&id=63921153"
import script from "./HomepageView.vue?vue&type=script&lang=js"
export * from "./HomepageView.vue?vue&type=script&lang=js"

import "./HomepageView.vue?vue&type=style&index=0&id=63921153&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__